import { distinctUntilChanged, map, Observable } from 'rxjs';
import { isEqual } from '@ardoq/common-helpers';
import {
  type FilterInterfaceFilter,
  isReferenceLabelFormatting,
} from '@ardoq/api-types';
import { DEFAULT_MULTI_LABEL_REFERENCE_FORMATTING_FILTER_ATTRIBUTES } from '@ardoq/graph';
import type { FormattingAndLabelRules } from '@ardoq/data-model';
import { formattingAndLabelRules$ } from './formattingAndLabelRules$';

const toReferenceLabelFilters = ({
  rules,
}: FormattingAndLabelRules): FilterInterfaceFilter[] => {
  const referenceLabelFilters = rules.filter(isReferenceLabelFormatting);
  return referenceLabelFilters.length > 0
    ? referenceLabelFilters
    : DEFAULT_MULTI_LABEL_REFERENCE_FORMATTING_FILTER_ATTRIBUTES;
};

export const referenceLabelFilters$: Observable<FilterInterfaceFilter[]> =
  formattingAndLabelRules$.pipe(
    map(toReferenceLabelFilters),
    distinctUntilChanged(isEqual)
  );
